export default "__VITE_ASSET__b$AikPBB__"